import React, { FC, ReactNode } from 'react'

import { FlexContainer } from '../FlexContainer'
import * as S from './Field.styles'

interface FieldProps {
  className?: string
  marginTop?: number
  title?: ReactNode
  info?: ReactNode
  subtitle?: ReactNode
}

export const Field: FC<FieldProps> = ({ className, marginTop, title, info, subtitle }) => {
  return (
    <S.Field className={className} marginTop={marginTop}>
      {title ? <S.Title>{title}</S.Title> : null}
      {info ? <S.Info>{info}</S.Info> : null}
      {subtitle ? <S.FieldSubtitle>{subtitle}</S.FieldSubtitle> : null}
    </S.Field>
  )
}

interface FieldAvatarProps extends FieldProps {
  avatar: ReactNode
}

export const FieldAvatarContent: FC<FieldAvatarProps> = ({
  className,
  avatar,
  marginTop,
  title,
  info,
  subtitle,
}) => {
  return (
    <S.Field className={className} marginTop={marginTop}>
      {title ? <S.Title>{title}</S.Title> : null}

      <FlexContainer gap={9} justify="flex-start">
        {avatar}

        <S.FieldSubtitle>
          <FlexContainer direction="column" alignItems="flex-start" full>
            {info}
            {subtitle ? <FlexContainer gap={4}>{subtitle}</FlexContainer> : null}
          </FlexContainer>
        </S.FieldSubtitle>
      </FlexContainer>
    </S.Field>
  )
}
